import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCompanyByUserIdApi, updateCompanyByCompanyIdApi } from '@src/api';

export const getCompanyById = createAsyncThunk(
  'company/getCompanyById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await getCompanyByUserIdApi(id);
      return response.result.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

export const updateCompanyById = createAsyncThunk(
  'company/updateCompanyById',
  async (
    { id, name }: { id: string; name: string; avatarUrl: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await updateCompanyByCompanyIdApi(id, {
        name,
      });
      return response.result;
    } catch (err) {
      throw rejectWithValue(err.response?.data);
    }
  }
);
